import React from 'react';
import TextComponent from '/components/forms-v2/Text.component';

const ProgramCodeSelect = ({ control }) => {
  return <TextComponent name='programCode' control={control} label='Programme Code' disabled />;
};

export default ProgramCodeSelect;
